import {Route, Routes} from "react-router-dom";
import ShipmentList from "./ShipmentList";
import RequireAuth from "../../components/RequireAuth";
import {PermissionLevel} from "../../app/api/model/user";
import ShipmentDetails from "./ShipmentDetails";

export default function Shipments() {
    return (
        <RequireAuth permissionLevel={PermissionLevel.VIEW_ONLY}>
            <Routes>
                <Route index element={<ShipmentList />} />
                <Route path=":shipmentId" element={<ShipmentDetails />} />
            </Routes>
        </RequireAuth>
    );
}
